export const getAppOnboardingPath = (platform?: string) => {
    if (typeof window === "undefined") return "/app-onboarding";
    const version = localStorage.getItem("app_onboarding_version");
    const path = version === "v2" ? "/app-onboarding/v2" : "/app-onboarding";
    return platform ? `${path}?platform=${platform}` : path;
};
